import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { ReactElement } from 'react';
import { components, GroupTypeBase, IndicatorProps } from 'react-select';

import { IOption } from '~/types';

const ClearIndicator = (
  props: IndicatorProps<IOption, boolean, GroupTypeBase<IOption>>,
): ReactElement => {
  const { selectProps, clearValue } = props;
  const { isOptionDisabled, isMulti, value } = selectProps;

  const disableOption = isOptionDisabled as ((option: IOption) => boolean) | undefined;
  const raw = value as IOption | readonly IOption[] | IOption | null | undefined;

  let disableClear = false;

  if (disableOption) {
    if (isMulti && Array.isArray(raw)) {
      disableClear =
        raw.length > 0 && raw.every(opt => Boolean(opt && disableOption(opt as IOption)));
    } else if (raw && typeof raw === 'object' && 'value' in raw && !Array.isArray(raw)) {
      disableClear = disableOption(raw as IOption);
    }
  }

  return (
    <components.ClearIndicator {...props}>
      {/* MUI disabled IconButton uses pointer-events: none — clicks pierce through to RS ClearIndicator */}
      <span
        style={{ display: 'inline-flex' }}
        onMouseDownCapture={
          disableClear
            ? e => {
                e.preventDefault();
                e.stopPropagation();
              }
            : undefined
        }
      >
        <IconButton
          disabled={disableClear}
          type="button"
          tabIndex={disableClear ? -1 : undefined}
          size="small"
          style={{ padding: 2 }}
          onMouseDown={e => {
            e.preventDefault();
            e.stopPropagation();
            if (!disableClear) {
              clearValue();
            }
          }}
        >
          <CloseIcon color="secondary" fontSize="small" />
        </IconButton>
      </span>
    </components.ClearIndicator>
  );
};

export default ClearIndicator;
